import { Component, OnInit, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Subject, Observable } from 'rxjs';
import * as _ from 'underscore';
import { RootStoreState } from 'src/app/root-store';
import { takeUntil } from 'rxjs/operators';
import { ColumnConfigItem } from 'src/app/models/ColumnConfigItem';

import { getCurrentUser } from 'src/app/root-store/main-app-store/selectors/auth.selector';
import { getCustomerList, getCustomerListError, getCustomerListLoading } from 'src/app/root-store/kwikspace-app-store/selectors/customer.selector';
import { Customer } from 'src/app/models/Customer.model';
import { ClearCustomerList, GetCustomerList } from 'src/app/root-store/kwikspace-app-store/actions/customer.action';
import { AppRoutes } from 'src/app/shared/endpoints.enum';
import { Router } from '@angular/router';
import { PaginationService } from 'src/app/services/pagination.service';

@Component({
  selector: 'kwikspace-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class CustomersComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject();

  customersLoading$: Observable<any> = this.store.select(getCustomerListLoading);
  customersError$: Observable<any> = this.store.select(getCustomerListError);

  customers: Customer[];
  pageCount = 1;
  pageLinks;
  itemCount = 0;
  currentPage = 1;
  pageToLoad;

  actionButtons: any[];
  iconClass: string;
  columnConfig: ColumnConfigItem[];

  filterBy: any;
  sortBy: any;
  searchTerm: any;

  hasCustomers: boolean = false;

  constructor(
    private router: Router,
    private store: Store<RootStoreState.RootState>,
    private paginationService: PaginationService
  ) { }

  ngOnInit() {
    this.actionButtons = [
      {
        name: 'Add Customer',
        id: 'addCustomer'
      }
    ];

    this.iconClass = 'fa fa-user text-white';

    this.columnConfig = [
      {
        oldName: 'id',
        isVisible: false
      },
      {
        oldName: 'role',
        isVisible: false
      },
      {
        oldName: 'firstName',
        isSortable: true
      },
      {
        oldName: 'lastName',
        isSortable: true
      },
      {
        oldName: 'email',
        isSortable: true
      },
      {
        oldName: 'company',
        isSortable: true
      },
    ];

    this.store
      .select(getCurrentUser)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res) => {
        if (res) {
          this.getCustomers();
        }
      });

    this.store
      .select(getCustomerList)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((customers: any) => {
        if (customers) {
          let _customers = customers.results ? customers.results : customers.length > 0 ? customers : [];

          this.itemCount = customers.count;
          this.pageLinks = customers.links;
          this.pageCount = this.itemCount < 10 ? 1 : Math.ceil(this.itemCount / 10);

          if (_customers.length > 0) {
            this.searchTerm = '';
            this.filterBy = '';
            this.sortBy = '';
          }

          this.buildCustomersTable(_customers);
        }
      });
  }

  buildCustomersTable(customers) {
    if (customers.length > 0) {
      customers.forEach(customer => {
        Object.keys(customer).forEach(key => {
          let obj = customer[key];
          if (obj) {
            if (key == 'company') {
              customer[key] = obj.name;
            }
            if (key == 'address') {
              customer[key] = obj.province.name + ' - ' + obj.suburb;
            }
          }
        });
      });
    }

    this.customers = customers;
    this.hasCustomers = true;
  }

  getCustomers() {
    this._reloadList();
  }

  viewItem(customerDetails: any) {
    const route = AppRoutes.PWA + AppRoutes.CUSTOMER_LIST + '/' + customerDetails.id;
    this.router.navigate([route]);
  }

  retry() {
    this.getCustomers();
  }

  sort(sortableOptions: any) {
    this.currentPage = 1;

    this.sortBy = sortableOptions;
    this._reloadList();
  }

  search(searchTerm: string) {
    this.currentPage = 1;

    this.searchTerm = searchTerm;
    this._reloadList();
  }

  paginate(page: string) {
    let pageProps: any = this.paginationService.getPageProps(page, this.pageCount, this.pageLinks);

    this.currentPage = pageProps.current;
    this.pageToLoad = pageProps.pageToLoad;

    this._reloadList();
  }

  private _reloadList() {
    this.store.dispatch(new ClearCustomerList());
    this._loadList();
  }

  _loadList() {
    this.store.dispatch(
      new GetCustomerList({
        search: this.searchTerm,
        sort: this.sortBy,
        page: this.pageToLoad,
      })
    );
  }

  actionClickEvent(action) {
    switch (action) {
      case 'addCustomer':
        this.addCustomer();
        break;
      default:
        this.addCustomer();
    }
  }

  addCustomer() {
    const route = AppRoutes.PWA + AppRoutes.NEW_CUSTOMER;
    this.router.navigate([route]);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
